const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Extracts the relative media path from any URL format.
 * Strips domain prefixes so media works across environments.
 */
function extractRelativePath(path) {
  if (!path || typeof path !== 'string') return '';
  const trimmed = path.trim();
  if (!trimmed) return '';

  // If it's an absolute URL, extract the path portion
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
    try {
      const url = new URL(trimmed);
      // If it contains our media path pattern, extract just the path
      if (url.pathname.includes('/api/media/file/') || url.pathname.includes('/media/')) {
        return url.pathname;
      }
      // External URL (e.g. unsplash) — return as-is
      return trimmed;
    } catch {
      return trimmed;
    }
  }
  return trimmed;
}

/**
 * Normalizes a media URL for consistent rendering across the app.
 * Returns RELATIVE paths for local media so images work on any domain
 * without depending on REACT_APP_BACKEND_URL.
 */
export function getMediaUrl(path) {
  const relative = extractRelativePath(path);
  if (!relative) return '';
  // External URLs that aren't our media paths
  if (relative.startsWith('http://') || relative.startsWith('https://')) return relative;
  // Normalize /media/filename → /api/media/file/filename so backend handles it (with object storage fallback)
  if (relative.startsWith('/media/') && !relative.startsWith('/media/file/')) {
    return '/api/media/file/' + relative.slice(7);
  }
  // Already correct format or other local paths
  if (relative.startsWith('/api/media/file/') || relative.startsWith('/')) return relative;
  // Bare filenames — prefix with /api/media/file/
  return `/api/media/file/${relative}`;
}

/**
 * Returns just the relative path for storage in the database.
 * Ensures media URLs are domain-agnostic.
 */
export function toRelativeMediaPath(url) {
  return extractRelativePath(url);
}
